import React, { useState, useEffect } from 'react'
import {
  Form,
  Input,
  Button,
  List,
  Avatar,
  Typography,
  Tooltip,
  Popconfirm,
  Spin,
  Timeline,
  Divider
} from 'antd'
import { EditOutlined, DeleteOutlined, UserOutlined } from '@ant-design/icons'
import moment from 'moment'
import {
  listNote,
  noteAdd,
  noteDelete,
  noteUpdate
} from '../../services/postservice'
import get from 'lodash.get'
import openNotification from '../common/Notification/openNotification '
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { bookHistory, requestHistory } from '../../services/requestservice'
import ModalCustom from '../common/Modal/ModalCustom'
import { fieldLabels, OPTIONS_ROLE } from '../../configData'
import { APARTMENT_TYPE, BALCONY_DIRECTION, FURNITURE_TYPE, identifierType, LabelType, NHU_CAU, POLICY_DOCUMENT, PROCCESS_TRANFER, ProductType, SECURITY_TYPE, status, statusList, SUB_PRODUCT_TYPE } from './configs'
import { OPTIONS_ROLE_USER } from '../PostManagement/configs'
import { formatCurrencyLabel } from '../../config-func'
dayjs.extend(utc)
dayjs.extend(timezone)
const { Text } = Typography

const formatDate = (timestamp) => {
  const date = new Date(Number(timestamp) * 1000)
  const options = { hour: '2-digit', minute: '2-digit' }
  const time = date.toLocaleTimeString('vi-VN', options)
  const dateStr = date.toLocaleDateString('vi-VN')
  return `(${time}) ${dateStr}`
}

const CallModal = ({ id, isOpen, setIsOpen, listDepartment, cities, districts, towns }) => {
  const [data, setData] = useState([])
  const [dataBook, setDataBook] = useState([])
  const [loading, setLoading] = useState(true)

   
// Hàm map value theo LabelType
const mapLabelType = (value) => {
  const found = LabelType.find(item => item.value === value);
  return found ? found.label : value;
};

// Hàm map value cho type_real_estate
const mapTypeRealEstate = (value) => {
  // Gộp hết các array con thành 1 array tổng
  const allTypes = [
    ...SUB_PRODUCT_TYPE.APARTMENT,
    ...SUB_PRODUCT_TYPE.BUILDING,
    ...SUB_PRODUCT_TYPE.REAL_ESTATE,
    ...SUB_PRODUCT_TYPE.GROUND
  ];
  const found = allTypes.find(item => item.value === value);
  return found ? found.label : value;
};

// map tên sàn
const mapDepartment = (value) => {
  const found = listDepartment.find(item => item.value === value);
  return found ? found.label : value;
};
// map tên Loại BDS
const mapPostType = (value) => {
  const found = ProductType.find(item => item.value === value);
  return found ? found.label : value;
};
// map tên Hướng
const mapDirection = (value) => {
  const found = BALCONY_DIRECTION.find(item => item.value === value);
  return found ? found.label : value;
};
// map tên vị trí
const mapLocation = (value) => {
  const found = APARTMENT_TYPE.find(item => item.value === value);
  return found ? found.label : value;
};
// map tên giấy tờ pháp lý
const mapLegal = (value) => {
  const found = POLICY_DOCUMENT.find(item => item.value === value);
  return found ? found.label : value;
};
// map tên phí giao dịch
const mapProcedure = (value) => {
  const found = PROCCESS_TRANFER.find(item => item.value === value);
  return found ? found.label : value;
};
// map tên nội thất
const mapFurniture = (value) => {
  const found = FURNITURE_TYPE.find(item => item.value === value);
  return found ? found.label : value;
};
// map hiện trạng
const mapStatus = (value) => {
  const found = status.find(item => item.value === value);
  return found ? found.label : value;
};
// map trạng thái
const mapProcessingStatus = (value) => {
  const found = statusList.find(item => item.value === value);
  return found ? found.label : value;
};
// map bảo mật
const mapSecutiry = (value) => {
  const found = SECURITY_TYPE.find(item => item.value === value);
  return found ? found.label : value;
};
// map thành phố
const mapCity = (value) => {
  const found = cities.find(item => item.code === value);
  return found ? found.name : value;
};
// map quận huyện
const mapDistrict = (value) => {
  const found = districts.find(item => item.code === value);
  return found ? found.name : value;
};
// map phường xã
const mapTown = (value) => {
  const found = towns.find(item => item.code === value);
  return found ? found.name : value;
};

// map Nhu cầu
const mapRequestType = (value) => {
  const found = NHU_CAU.find(item => item.value === value);
  return found ? found.label : value;
};
// map Định danh
const mapIdentifierType = (value) => {
  const found = identifierType.find(item => item.value === value);
  return found ? found.label : value;
};

const CompareChangedFields = ({ oldDataStr, newDataStr }) => {
  const oldData = JSON.parse(oldDataStr)
  const newData = JSON.parse(newDataStr)
  
  const changedFields = []

  for (const key in newData) {
    if (JSON.stringify(oldData[key]) !== JSON.stringify(newData[key])) {
      changedFields.push({
        key,
        oldValue: oldData[key],
        newValue: newData[key]
      })
    }
  }

    // Định dạng giá trị để hiển thị an toàn trong JSX
    const formatValue = (value) => {
      if (value === null || value === undefined) return "_"
      const valueType = typeof value
      if (valueType === "string" || valueType === "number" || valueType === "boolean") {
        return value
      }
      try {
        return JSON.stringify(value)
      } catch (_) {
        return "[Object]"
      }
    }

  if (changedFields.length === 0) {
    return <p>Không có thay đổi.</p>
  }

  return (
    <div>
      <ul>
        {changedFields.map((field) => {
          const label = fieldLabels[field.key] || field.key;

          let oldVal = field.oldValue;
          let newVal = field.newValue;

          if (field.key === "label") {
            oldVal = mapLabelType(oldVal);
            newVal = mapLabelType(newVal);
          }

          if (field.key === "type_real_estate") {
            oldVal = mapTypeRealEstate(oldVal);
            newVal = mapTypeRealEstate(newVal);
          }
          if (field.key === "department_id") {
            oldVal = mapDepartment(oldVal);
            newVal = mapDepartment(newVal);
          }
          if (field.key === "post_type") {
            oldVal = mapPostType(oldVal);
            newVal = mapPostType(newVal);
          }
          if (field.key === "direction") {
            oldVal = mapDirection(oldVal);
            newVal = mapDirection(newVal);
          }
          if (field.key === "apartment_location") {
            oldVal = mapLocation(oldVal);
            newVal = mapLocation(newVal);
          }
          if (field.key === "legal") {
            oldVal = mapLegal(oldVal);
            newVal = mapLegal(newVal);
          }

          if (field.key === "procedure") {
            oldVal = mapProcedure(oldVal);
            newVal = mapProcedure(newVal);
          }
          if (field.key === "furniture") {
            oldVal = mapFurniture(oldVal);
            newVal = mapFurniture(newVal);
          }
          if (field.key === "status") {
            oldVal = mapStatus(oldVal);
            newVal = mapStatus(newVal);
          }
          if (field.key === "processing_status") {
            oldVal = mapProcessingStatus(oldVal);
            newVal = mapProcessingStatus(newVal);
          }
          if (field.key === "security") {
            oldVal = mapSecutiry(oldVal);
            newVal = mapSecutiry(newVal);
          }
          if (field.key === "price" || field.key === "cost") {
            oldVal = formatCurrencyLabel(oldVal);
            newVal = formatCurrencyLabel(newVal);
          }
          if (field.key === "updated_at") {
            oldVal = oldVal ? formatDate(oldVal) : "_";
            newVal = newVal ? formatDate(newVal) : "_";
          }
          if (field.key === "city_code" && cities.length > 0) {
            oldVal = mapCity(oldVal);
            newVal = mapCity(newVal);
          }
          if (field.key === "district_code" && districts.length > 0) {
            oldVal = mapDistrict(oldVal);
            newVal = mapDistrict(newVal);
          }
          if (field.key === "town_code" && towns.length > 0) {
            oldVal = mapTown(oldVal);
            newVal = mapTown(newVal);
          }
          if (field.key === "request_type") {
            oldVal = mapRequestType(oldVal);
            newVal = mapRequestType(newVal);
          }
          if (field.key === "identifier_type") {
            oldVal = mapIdentifierType(oldVal);
            newVal = mapIdentifierType(newVal);
          }
          if (field.key === "full_text_search") {
            return null
           }
          // return (
          //   <li key={field.key} style={{display: 'flex', gap: 5, margin: '5px 0px -10px 0px'}}>
          //     - Sửa {label} từ <p style={{fontWeight: 600}}>{oldVal ?? "_"} {'->'} {newVal ?? "_"}</p> 
          //   </li>
          // );
          return (
            <li key={field.key} style={{ display: 'flex', gap: 4, margin: '5px 0px 0px 0px' }}>
              <span style={{ whiteSpace: 'nowrap' }}>- Sửa {label} : từ</span>
              <p style={{ fontWeight: 600, margin: 0, wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                {formatValue(oldVal)} {'->'} {formatValue(newVal)}
              </p>
            </li>
          );
        })}
      </ul>
    </div>
  )
}

  // Danh sách note
  const getListNote = async () => {
    setLoading(true)
    const params = {
      request_id: id,
      // type: '6'
    }
    
    try {
      const res = await requestHistory(params)

      if (res?.data) {
        const mapData = res?.data?.list?.map((i) => {
          const create_at = formatDate(i.created_at)
          const userRole = i?.user_info ? OPTIONS_ROLE_USER.find(
            (item) => item.value === i?.user_info?.user_role
          ) : 'User anomyous'
          const userName = i?.user_info?.name || 'User anomyous'
          const callUserRole = i?.call_user_info ? OPTIONS_ROLE_USER.find(
            (item) => item.value === i?.call_user_info?.permission_info?.name
          ) : 'User anomyous'

          const userPermissionName = i?.user_info?.permission_info?.name || 'User anomyous'

          if (i.type == 2) {
            return {
              children: (
                <div style={{ marginBottom: '-10px' }}>
                  <p>{create_at}</p>
                  <div style={{ color: 'orange', display: 'flex', gap: 5, margin: '-10px 0px 5px 0px' }}>
                    {`(${userRole?.name || 'User anomyous'}) ` }
                    { userPermissionName} <span>{'=> ID: ' + i.id}</span>
                  </div>
                  <CompareChangedFields
                    oldDataStr={i.old_data}
                    newDataStr={i.new_data}
                  />
                </div>
              )
            }
          } else if (i.type == 5) {
            return {
              children: (
                <div style={{ marginBottom: '-10px' }}>
                  <p>{create_at}</p>
                  <div style={{ color: 'orange', display: 'flex', gap: 5, margin: '-10px 0px 5px 0px' }}>
                    {userRole?.label || 'User anomyous'} {userName}{' '}
                    <p style={{ color: '#000' }}>phân quyền</p>{' '}
                    {callUserRole?.name}
                  </div>
                </div>
              )
            }
          } else if (i.type == 6) {
            return {
              children: (
                <div style={{ marginBottom: '-10px' }}>
                  <p>{create_at}</p>
                  <div style={{ color: 'orange', display: 'flex', gap: 5, margin: '-10px 0px 5px 0px' }}>
                    {userRole?.label || 'User anomyous'} {userName}{' '}
                    <p style={{ color: '#000' }}> gọi điện cho </p> {callUserRole?.name}
                  </div>
                </div>
              )
            }
          } else if (i.type == 7) {
            return {
              children: (
                <div style={{ marginBottom: '-10px' }}>
                  <p>{create_at}</p>
                  <div style={{ color: 'orange', display: 'flex', gap: 5, margin: '-10px 0px 5px 0px' }}>
                    {userRole?.label || 'User anomyous'} {userName}{' '}
                    <p style={{ color: '#000' }}>chia sẻ</p>{' '}
                    {callUserRole?.name}
                  </div>
                </div>
              )
            }
          } else if (i.type == 8) {
            return {
              children: (
                <div style={{ marginBottom: '-10px' }}>
                  <p>{create_at}</p>
                  <div style={{ color: 'orange', display: 'flex', gap: 5, margin: '-10px 0px 5px 0px' }}>
                    {`(${userRole?.name || 'User anomyous'}) ${userPermissionName}`} <p style={{ color: '#000' }}>Note : {i.note}</p> 
                  </div>
                </div>
              )
            }
          }
        })
        setData(mapData)
      }
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  // Danh sách note
  const getListBook = async () => {
    setLoading(true)
    try {
      const res = await bookHistory(id)

      if (res?.data) {
        const mapData = res?.data?.list?.map((i) => {
          const create_at = formatDate(i.created_at)
          return {
            children: (
              <div style={{ marginBottom: '-10px' }}>
                <p>{create_at}</p>
                <p style={{ color: '#000', marginBottom: '5px' }}>
                  + Người book :{' '}
                  <span style={{ color: 'orange' }}>
                    {i?.user_booker_info?.name}
                  </span>
                </p>
                <p style={{ color: '#000', marginBottom: '5px' }}>
                  + Người lên book :{' '}
                  <span style={{ color: 'orange' }}>
                    {i?.user_create_book_info?.name}
                  </span>
                </p>
                <p style={{ color: '#000', marginBottom: '5px' }}>
                  + Loại book :{' '}
                  <span style={{ color: 'orange' }}>{i?.type}</span>
                </p>
                <p style={{ color: '#000', marginBottom: '5px' }}>
                  + Nội dung :{' '}
                  <span style={{ color: 'orange' }}>{i?.content}</span>
                </p>
              </div>
            )
          }
        })
        setDataBook(mapData)
      } else {
        setDataBook([])
        // openNotification('error', 'Không có dữ liệu book')
      }
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (isOpen) {
      getListNote()
      getListBook()
    }
  }, [isOpen])

  return (
    <ModalCustom
      title="Lịch sử"
      visible={isOpen}
      centered
      width={600}
      // className="modal-bond"
      onCancel={() => {
        setIsOpen(false)
      }}
      cancelText="Đóng"
    >
     {loading ? <div style={{ maxWidth: '100%', margin: 'auto', padding: '10px 26px', display: 'flex', justifyContent: 'center' }}><Spin /></div> : (
        data.length > 0 ? (
          <div style={{ maxWidth: '100%', margin: 'auto', padding: '10px 26px' }}>
            <Timeline items={[...data, ...dataBook]} />
          </div>
        ) : (
          <div style={{ maxWidth: '100%', margin: 'auto', padding: '10px 26px', display: 'flex', justifyContent: 'center' }}>
            <p>Không có dữ liệu</p>
          </div>
        )
      )}
    </ModalCustom>
  )
}

export default CallModal
